export default __webpack_public_path__ + "static/media/base-1-min.0feab1fe.jpg";